import React from 'react';
import { Question } from 'types/questionnaire/types';

interface YesNoQuestionProps {
  question: Question;
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
  error?: string;
  stopWarning?: boolean;
}

const YesNoQuestion: React.FC<YesNoQuestionProps> = ({ question, value, onChange, error, stopWarning }) => {
  const yesText = question.yesLabel || 'Yes';
  const noText = question.noLabel || 'No';
  return (
    <fieldset className="flex flex-col gap-6">
      <legend className="text-lg font-semibold leading-7 tracking-tight text-brand-black mb-6">{question.text}</legend>
      {question.description && <p className="text-sm text-brand-black/80">{question.description}</p>}
      {question.content && question.content.length > 0 && (
        <ul className="list-disc pl-5 text-sm text-brand-black/80">
          {question.content.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      )}
      {stopWarning && (
        <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">
          Unfortunately based on this answer, you are not suitable for ED treatment, please choose a different answer if
          appropriate or contact us for medical advice
        </div>
      )}
      <div className="flex flex-col gap-4">
        <button
          type="button"
          className={`w-full rounded-lg border px-4 py-2 text-left text-base font-normal leading-6 tracking-[-0.44px] text-brand-black transition-colors ${
            value === true
              ? 'border-talo-dark-green bg-talo-dark-green text-white'
              : 'questionnaire-answer-option border-gray-300 bg-white text-brand-black'
          }`}
          onClick={() => onChange(true)}
        >
          {yesText}
        </button>
        <button
          type="button"
          className={`w-full rounded-lg border px-4 py-2 text-left text-base font-normal leading-6 tracking-[-0.44px] text-brand-black transition-colors ${
            value === false
              ? 'border-talo-dark-green bg-talo-dark-green text-white'
              : 'questionnaire-answer-option border-gray-300 bg-white text-brand-black'
          }`}
          onClick={() => onChange(false)}
        >
          {noText}
        </button>
      </div>
      {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
    </fieldset>
  );
};

export default YesNoQuestion;
